var _radialGradient, _circle, _linearGradient, _path, _linearGradient2, _path2, _radialGradient2, _path3, _linearGradient3, _linearGradient4, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuery({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    viewBox: "0 0 540 540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    cy: 712.62,
    cx: 52.446,
    gradientTransform: "matrix(-1.5341 .00904 .0086 1.4606 344.19 -883.69)",
    r: 233.79
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF53C",
    offset: 0.778
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DC4D",
    offset: 0.959
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD00A",
    offset: 1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 261,
    cx: 269.9,
    cy: 269.8,
    stroke: "#AD8D00",
    strokeWidth: 15.819,
    fill: "url(#a)"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    y2: 283.11,
    gradientUnits: "userSpaceOnUse",
    x2: 62.854,
    gradientTransform: "matrix(1.0171 0 0 -1.0169 209.17 781.61)",
    y1: 889.75,
    x1: 55.815
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D1D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE96",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDC5",
    offset: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270.5 25.7c-134.3 0-243.4 109-243.4 243.3s109.1 243.3 243.4 243.3S513.9 403.2 513.9 269 404.8 25.7 270.5 25.7zm0 12.2c127.7 0 231.2 103.5 231.2 231.1S398.2 500.1 270.5 500.1 39.3 396.6 39.3 269c0-127.7 103.5-231.1 231.2-231.1z",
    fill: "url(#b)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y2: 743.52,
    gradientUnits: "userSpaceOnUse",
    x2: 54.962,
    gradientTransform: "matrix(1.059 0 0 -1.0587 206.02 803.53)",
    y1: 274.65,
    x1: 65.398
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFB9B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF527",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF46E",
    offset: 1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M269.9 16.5C130.1 16.5 16.5 130 16.5 269.8s113.6 253.3 253.4 253.3 253.4-113.6 253.4-253.3S409.7 16.5 269.9 16.5zm0 12.7c132.9 0 240.7 107.7 240.7 240.6S402.8 510.4 269.9 510.4C137 510.4 29.2 402.7 29.2 269.8S137 29.2 269.9 29.2z",
    fill: "url(#c)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    cy: 563.78,
    cx: 635.41,
    gradientTransform: "matrix(0 .5708 1.3997 0 -519.02 -132.67)",
    r: 227.65
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7BB",
    offset: 1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M275.4 9.2c-109.7 0-203.3 59.8-242 151C72 251.4 154.6 311 264.4 311c109.7 0 203.7-64.4 242.4-155.5C468.1 64.3 385.1 9.2 275.4 9.2z",
    fill: "url(#d)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    y2: -278.95,
    gradientUnits: "userSpaceOnUse",
    x2: 481.45,
    gradientTransform: "matrix(1.1107 .1846 .1515 -1.0073 -219.86 64.017)",
    y1: 41.698,
    x1: 447.03
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5174A6",
    offset: 1
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    y2: 46.158,
    gradientUnits: "userSpaceOnUse",
    x2: 459.62,
    y1: -278.83,
    x1: 508.12
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#453CA6",
    offset: 1
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#e)",
    strokeWidth: 6.424,
    d: "M380.8 212.6c-3 20.2-13.4 38.3-31.2 54.3s-46 31.8-84.6 47.4c-7.8 3.1-12.6 11-14.6 23.8-.2 1.1-.1 4.1.2 9 .3 5.1.4 8.2.2 9.5-.4 2.8-3.1 5.2-8 6.9-4.9 1.6-9.9 2-15.2 1.1-8.4-1.4-14.5-4-18.4-7.9-3.7-4-6.6-11-8.6-20.9-2.1-10.1-2.6-18.1-1.7-24.1 2.1-13.7 11.8-23.5 29.3-29.1 57.9-19.4 89.5-46.4 94.7-81.2 2.4-16.1-.8-29.8-9.6-41-8.8-11.3-20.9-18.3-36.2-20.8-18.1-3-35.2.6-51.2 10.7-9.3 5.9-17.1 8.3-23.6 7.3-6.3-1-11.7-4.1-16.3-9.3-4.6-5.1-6.6-9.6-6-13.4 2.2-14.5 13.5-25.3 34.1-32.2 20.5-7.1 42.7-8.7 66.4-4.8 33.6 5.6 59.8 19.1 78.6 40.5 18.7 21.4 26 46.1 21.7 74.2M252.2 428.1c-.8 5.2-4.4 9.1-10.9 11.8-6.5 2.8-13.7 3.6-21.5 2.3-20.9-3.5-30-14-27.4-31.5 1-6.5 5.1-11.8 12.3-15.9 7.3-4.3 14.9-5.8 22.9-4.5 7.3 1.2 13.4 6.2 18.4 15 5.2 8.6 7.2 16.2 6.2 22.8",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M269.9 0C121 0 0 121 0 269.8s121 269.8 269.9 269.8 269.9-121 269.9-269.8C539.7 121 418.8 0 269.9 0zm0 17.7C409.2 17.7 522 130.5 522 269.8S409.2 521.9 269.9 521.9 17.7 409.1 17.7 269.8 130.6 17.7 269.9 17.7z",
    fill: "#AD6D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuery);
export default __webpack_public_path__ + "static/media/query.d56017dcb21dc32a592fec41b7ef41bd.svg";
export { ForwardRef as ReactComponent };